import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesComponent } from './pages/pages.component';
import { LinkerModule, LinkerService } from '@clavisco/linker';
import { AppSettings } from './app.settings';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { OverlayModule, OverlayService } from '@clavisco/overlay';
import { AlertsModule, AlertsService } from '@clavisco/alerts';
import { Miscellaneous } from '@clavisco/core';
import { MenuComponent } from "./shared/menu/menu.component";
import { UrlInterceptor } from './interceptors/url.interceptor';
import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { ErrorInterceptor } from "./interceptors/error.interceptor";

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    MenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    LinkerModule,
    AlertsModule,
    OverlayModule
  ],
  providers: [
    AppSettings,
    {
      provide: 'LinkerService',
      useClass: LinkerService
    },
    {
      provide: 'OverlayService',
      useClass: OverlayService
    },
    {
      provide: 'AlertsService',
      useClass: AlertsService
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recatchaSiteKey
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.HttpAlertInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.PagedRequestInterceptor,
      multi: true
    },
    {
      useClass: UrlInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    },
    {
      useClass: AuthenticationInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    },
    {
      useClass: ErrorInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
